import { EssModalCustomElement } from 'app/shared/elements/ess-dialog';
import { Api } from 'app/shared/lib/api/api';
import { isScrolledToBottom } from 'app/shared/lib/dom';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { noop } from 'app/shared/lib/noop';
import { EnvironmentService } from 'app/shared/services/environment-service';
import { httpRequest } from 'app/shared/services/http-service';
import { autoinject } from 'aurelia-framework';

@autoinject()
export class EssUserAgreementModalCustomElement {

    protected userAgreement!: string;
    protected userAgreementLoaded!: Promise<string>;
    protected didScrollToEnd = false;

    // refs
    protected $modal!: EssModalCustomElement;
    private resolve: (success: boolean) => void = noop;
    protected checkIfScrolledToBottom = () => {
        const body = this.$modal.$body;
        this.didScrollToEnd = isScrolledToBottom(body);
        if(this.didScrollToEnd) {
            body.removeEventListener('scroll', this.checkIfScrolledToBottom);
        }
    };

    constructor(
        protected readonly api: Api,
        protected readonly env: EnvironmentService,
        protected readonly logger: AppLogger
    ) {
        this.logger.source = this;
        this.logger.target = 'console';
        if(env.config.agreementFile) {
            this.userAgreementLoaded = httpRequest(env.config.agreementFile, { format: 'raw' })
                .then((userAgreement) => this.userAgreement = userAgreement);
        }
    }

    protected listenForScrolling() {
        const body = this.$modal.$body;
        this.didScrollToEnd = isScrolledToBottom(body);
        if(!this.didScrollToEnd) {
            body.addEventListener('scroll', this.checkIfScrolledToBottom);
        }
    }

    public async open(): Promise<boolean> {
        await this.userAgreementLoaded;
        this.listenForScrolling();
        this.$modal.open();
        return new Promise<boolean>((resolve) => this.resolve = resolve);
    }

    protected close() {
        this.$modal.close();
        this.$modal.$body.scrollTop = 0;
    }

    protected agree() {
        this.resolve(true);
        this.close();
    }

    protected cancel(): void {
        this.resolve(false);
        this.close();
    }
}
